import { IProzessDto, KeyValueDto } from "../../../api/backend-api-v7";
import { ILocalFerkelDto } from "../../../db/database";
import {
  ProzessEventOperationTypes,
  ProzessInputData,
} from "../../../store/prozess-events/prozess-events.actions";

export interface OwnProps {
  prozess: IProzessDto;
  recordId: string;
}

export interface ConnectedState {
  givenData: ProzessInputData | undefined;
  prevRecordId: string;
  isManuallyEmpty: boolean;
  isEditing: boolean;
  editedValue: KeyValueDto[] | undefined;
  ferkel: ILocalFerkelDto[];
}

export interface ConnectedDispatch {
  onChanged: (prozessInputData: ProzessInputData) => void;
  givenDataApplied: (workflowId: number) => void;
}

export interface Props extends OwnProps, ConnectedState, ConnectedDispatch {}

export interface KeyValueInfoTableState {
  value: KeyValueDto[] | undefined;
  isError: boolean;
  isValid?: boolean;
  isProzessEdited?: boolean;
}

export interface KeyValueInfoTableAction {
  type: KeyValueInfoTableActionType;
  payload: {
    value: KeyValueDto[] | undefined;
    isRequired?: boolean;
    status: ProzessEventOperationTypes;
    isValid?: boolean;
    isProzessEdited?: boolean;
  };
}

export enum KeyValueInfoTableActionType {
  INIT,
  PROZESS_DATA_CHANGED,
  RESET,
  PROZESS_DATA_EDITED,
}
